import { Helmet } from 'react-helmet-async';
import { useParams } from 'react-router-dom';

import { Content } from './components/Content';

export const AdminTransactionsPage = () => {
  const { billingAccountId } = useParams<{ billingAccountId?: string }>();

  return (
    <>
      <Helmet>
        <title>Transactions - AutoScript Admin</title>
      </Helmet>

      <Content billingAccountId={billingAccountId} />
    </>
  );
};
